import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConsoleService, HrefResolverService, ServicePathProviderService } from '@blk/cwp-ng-framework';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SearchResults } from '../gls/models/search-results';

@Injectable()
export class SearchResultsService {
	constructor(
		private http: HttpClient,
		private hrefService: HrefResolverService,
		private servicePathProviderService: ServicePathProviderService,
		private consoleService: ConsoleService
	) { }

	public getSearchResults(apiEndPoint: string): Observable<SearchResults> {
		return this.getSearchResultsInternal(apiEndPoint);
	}

	public getSearchResultsInternal(apiEndPoint: string): Observable<SearchResults> {
		return this.http.get(this.hrefService.getResolvedUrl(apiEndPoint)).pipe(map(this.extractData));

		// uncomment the below to get it working on devServer.
		// return this.http.get("../../../../assets/dummy-backend-data/search-results.json").map((response: Response) => response.json());
	}

	public optIn(): Observable<any> {
		return this.http.get(this.hrefService.getResolvedUrl('mySubscriptionsOptIn'));
	}

	private extractData(searchResults: SearchResults): SearchResults {
		searchResults.searchRecords.forEach(r => (r.documentPath = r.documentPath.replace(/^\/literature/, '')));
		return searchResults;
	}
}
